import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
import { CurrencyOutputDTO } from 'src/services/payment/currency/currencyDTO'

class CurrencyServices {
  async getTotalByCurrency(items : any): Promise<CurrencyOutputDTO> {
    try {
      const res = await axios.put(`${process.env.REACT_APP_URL_PAYMENT}/currency/items`, items, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error;
    }
  }

  async getByAll(): Promise<CurrencyOutputDTO[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_PAYMENT}/currency/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}

export const currencyServices = new CurrencyServices()
